export const getWindowDimensions = () => {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
};

export const mapWidthToThresholds = (width: number) => {
  return {
    isAtLeastSmall: width >= 640,
    isAtLeastMedium: width >= 768,
    isAtLeastLarge: width >= 1024,
    isAtLeastXL: width >= 1280,
    isAtLeast2XL: width >= 1536,
  };
};
